const Index = () => import('@/view/Index');
const apiManage = () => import('@/view/base/api-manage');
const organizationalStructureSetting = () => import('@/view/base/organizational-structure-setting');
const powerManage = () => import('@/view/base/power-manage');
const staffManage = () => import('@/view/base/staff-manage');
// const operationLog = () => import('@/view/base/operation-log');
export default [{
  path: '/index',
  name: 'index',
  component: Index
}, {
  path: '/api-manage',
  name: 'apiManage',
  component: apiManage
}, {
  path: '/organizational-structure-setting',
  name: 'organizationalStructureSetting',
  component: organizationalStructureSetting
}, {
  path: '/power-manage',
  name: 'powerManage',
  component: powerManage
}, {
  path: '/staff-manage',
  name: 'staffManage',
  component: staffManage
}];